import { index } from "./components/index";
import { animation } from "./components/animation";

index();
animation();


$(function () {

  $(document).on('click', '.navopen', function () {
    $('.header').toggleClass('is__active');
  });
  $(document).on('click', '.modal__open', function () {
    $('body').append('<div class="modal__bg"></div>');
    $('.modal__bg').fadeIn();
    let modal = '#' + $(this).attr('data-target');
    $(modal).fadeIn();
    $('.modal__bg, .modal__box__close').off().click(function () {
      $('.modal__box').fadeOut();
      $('.modal__bg').fadeOut('slow', function () {
        $('.modal__bg').remove();
      });
    });
  })

  $(document).on('click', '.modal__switch', function () {
    $(this).parents('.modal__box').fadeOut();
    var modal = '#' + $(this).attr('data-target');
    $(modal).fadeIn();
  });
})
